<template>
    <CheckboxGroup
      class="formily-checkbox"
      :options="options"
      :position="position"
      :horizontal="horizontal"
      :hollowStyle="hollowStyle"
      v-model="model"
    >
    </CheckboxGroup>
</template>

<script>
import { CheckboxGroup } from '@didi/rich-ui'
export default {
  components: { CheckboxGroup },
  props: {
    options: {},
    position: {
      default: 'right'
    },
    horizontal: {},
    hollowStyle: {},
    value: {
      default: () => ([])
    }
  },
  computed: {
    model: {
      get () {
        return this.value || []
      },
      set (newVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
